import React, {useState, useEffect} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {ApolloContext} from "../../atom/Apollo_Context";
import axios from "axios";
import moment from "moment";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import Card from "@material-ui/core/Card/Card";
import {Event} from "./HeraModel"
import {hera_events_path} from "../../atom/Apollo_links"
import {STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {createMuiTheme} from "@material-ui/core/styles";
import MUIDataTable, {MUISortOptions, SelectableRows} from "mui-datatables";
import {MuiThemeProvider} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {APOLLO_PAGE_ID, createApolloPageSizeTableOptions} from "../../common/Apollo_LocalStorageSettings";

// エラーメッセージ
const ERROR_MESSAGE = [
  "データ取得に失敗しました",
];

/*
    画面名：
 */
const HeraEventsPage: React.FC = () => {
  const classes = apollo_useStyles();
  const [events, setEvents] = useState<Event[]>([])
  const {state} = React.useContext(ApolloContext);
  const trackerId = state.current.trackerId

  const {data, setmsg} = React.useContext(ApolloMessage);

  useEffect(() => {

    // トラッカーIDが設定されていない場合の処理
    if (!trackerId) {
      return setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "トラッカーIDが設定されていません。広告主アカウント詳細画面からトラッカーIDを発行して下さい。"
        }
      });
      return;
    }

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_events_path}/${trackerId}`
    const fetchData = async () => {
      await axios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          }
        }
      ).then(result => {
        if (result.data.resultcode === 0) {
          setEvents(result.data.result);
        } else {
          console.log(result.data.message);
          const errMsg = result.data.message ? result.data.message : ERROR_MESSAGE[0];
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg
            }
          });
        }
      }).catch(err => {
        const errMsg = err.message ? err.message : ERROR_MESSAGE[0];
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg
          }
        });
      })
        .finally(() => {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false
            }
          })
        });
    };
    fetchData();
  }, []);

  const theme = createMuiTheme({});
  const columns = [
    {
      name: "ID",
      label: "イベントID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "name",
      label: "イベント名",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "latestRecord",
      label: "最新記録",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return moment(value).format("YYYY-MM-DD") !== "0001-01-01" ? moment(value).format("YYYY-MM-DD") : '';
        }
      }
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "ID",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.HERA_EVENTS) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.HERA_EVENTS,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <React.Fragment>
        <ApolloBreadcrumbs bread_no={49} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                           platform={""}/>
        <CustomizedSnackbars/>
        <Card className={classes.root} square variant="outlined">
          <MuiThemeProvider theme={theme}>
            <MUIDataTable
              title={
                <Typography variant="caption">
                  {"※パフォーマンス広告を実施の際は、イベント名「dadoptpoint」のイベントタグの設置が必須となります。"}
                  <br/>
                  {"　こちらのイベントタグを設置した箇所が最適化ポイントとなり、最適化ポイントCVとして計測されます。"}
                  <br/>
                  {"　最適化ポイントCVは測定ポイントを作成頂く必要はありませんが、1つ以上の測定ポイントが紐づいているキャンペーンのみ計測対象となりますのでご注意ください。"}
                </Typography>
              }
              data={events ? events : []}
              columns={columns}
              options={createApolloPageSizeTableOptions(options, APOLLO_PAGE_ID.EVENT_LIST)}
            />
          </MuiThemeProvider>
        </Card>
      </React.Fragment>
    </GenericTemplate>
  );
};

export default HeraEventsPage;
